export class LocationMap {
    constructor(optionalOptions = {}) {
        this._map = document.getElementById("map-canvas");

        if (!this._map) {
            this.destructor();
            return true;
        }

        let script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg&callback&callback=initMap';
        script.async = true;

        window.initMap = function() {
            navigator.geolocation.getCurrentPosition(success, error);
        }

        function success(pos) {
            let map = new google.maps.Map(this._map, {
                center: { lat: -34.397, lng: 150.644 },
                zoom: 8,
            });
        }

        function error(err) {
            console.log(('ERROR(' + err.code + '): ' + err.message));
        }

        document.head.appendChild(script);
    }

    destructor() {
        this._map = null;
    }
}

export default new LocationMap();